// extracted by mini-css-extract-plugin
module.exports = {"LinkList":"LinkList--2DiKR","LinkList-li":"LinkList-li--uIujN","LinkList-a":"LinkList-a--3gAWU"};